<template>
	<layer class="opt_more_g" name="move">
		<div class="box_opt_menu opt_menu_board">
			<div class="menu_item" v-for="({fldid, fldname}) in boards">
				<a href="javascript:" class="link_menu" @click="callback(fldid)">{{ fldname }}</a>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		boards: {
			type: Array,
			default: () => ([])
		},
		callback: {
			type: Function,
			default: () => null
		}
	}
}
</script>
